var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21297_15601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50911 8.21088L6.17578 6.04421L1.80078 10.1121L2.67578 10.9246L6.17578 7.66921L8.50911 9.83588L13.4674 4.65755L12.6449 3.8938L8.50911 8.21088Z",
    fill: "#323640"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21297_15601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 13,
    fill: "white",
    transform: "translate(0.633789 0.90918)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowChart);
export default __webpack_public_path__ + "static/media/show_chart.ca63805c0b803747cfeabd9e2a66383c.svg";
export { ForwardRef as ReactComponent };